import React from 'react';
import { Phone, MapPin, Clock, MessageCircle, Mail, Facebook, Instagram } from 'lucide-react';
import { advisorInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_perodua-advisor/artifacts/bnpfbniz_IMG_4155.png" 
                  alt="Perodua Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">{advisorInfo.name}</h3>
                <p className="text-pink-400 font-medium">{advisorInfo.title}</p>
              </div>
            </div>
            
            <p className="text-slate-300 mb-6 leading-relaxed">
              Trusted Perodua Sales Advisor dengan pengalaman bertahun-tahun membantu pelanggan 
              mendapatkan kereta impian mereka. Kami komited memberikan perkhidmatan terbaik 
              dengan proses loan yang mudah dan cepat.
            </p>

            <div className="bg-slate-800 rounded-xl p-6">
              <h4 className="font-semibold text-lg mb-4 text-pink-400">"{advisorInfo.tagline}"</h4>
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center space-x-2 text-green-400">
                  <MessageCircle className="w-5 h-5" />
                  <span className="font-medium">WhatsApp Available 24/7</span>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <a 
                  href={advisorInfo.tiktokLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-pink-400 hover:text-pink-300 transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                  </svg>
                  <span className="font-medium">Follow di TikTok</span>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium">{advisorInfo.phone}</p>
                  <p className="text-sm text-slate-400">Call / WhatsApp</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium">Lokasi:</p>
                  <p className="text-sm text-slate-300">{advisorInfo.location}</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-medium">Operating Hours:</p>
                  <p className="text-sm text-slate-300">Mon - Sun: 9AM - 10PM</p>
                  <p className="text-sm text-green-400">WhatsApp: 24/7</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-slate-300">Loan Processing</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-slate-300">Trade-In Services</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-slate-300">Insurance Claims</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-slate-300">After Sales Support</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-slate-300">Maintenance Booking</span>
              </div>
            </div>

            {/* Quick Contact */}
            <div className="mt-8">
              <button 
                onClick={() => window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent('[Website] PM PERODUA - Hi Syasyah, saya dari website anda dan nak contact untuk kereta Perodua.')}`, '_blank')}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center space-x-2"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp Now</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-slate-400 text-sm">
                © {currentYear} Syasyah Perodua. All rights reserved.
              </p>
              <p className="text-slate-500 text-xs mt-1">
                Perodua Lon G Setia Auto 3S Kayu Ara, Damansara
              </p>
            </div>
            
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2 text-slate-400 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>Online Now</span>
              </div>
              
              <div className="flex items-center space-x-4">
                <a 
                  href={advisorInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-green-400 transition-colors"
                >
                  <MessageCircle className="w-5 h-5" />
                </a>
                <a 
                  href={`tel:${advisorInfo.phone}`}
                  className="text-slate-400 hover:text-blue-400 transition-colors"
                >
                  <Phone className="w-5 h-5" />
                </a>
                <a 
                  href={advisorInfo.tiktokLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-pink-400 transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent('[Website] PM PERODUA - Hi Syasyah, saya dari website anda dan nak contact untuk kereta Perodua.')}`, '_blank')}
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 animate-pulse"
        >
          <MessageCircle className="w-6 h-6" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;